import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ProductPartAction } from '../../actions';
import { RayForm, RayFormValidation } from '../common';
import { RayCodeAction } from '../../actions/RayCodeAction';
import { DeviceModels } from '../../config/RayCodes';
import { FileAddList } from '../../components/common/FileAddList';
import { RayDelButton, EditSaveCancelBar } from '../../components/common/Buttons';
import { Translate as t } from '../../config/Translate';
import { useBatchEdit } from '../../hooks/useBatchEdit';

// 편집 칸 — 서버 값 → 입력 draft(키 = RayForm 칸 name = 서버로 보내는 키)
const toDraft = (p) => ({
	type: p?.type, models: p?.models, code: p?.code, name: p?.name,
	productextrakey: p?.productextrakey, platformInfo: p?.platformInfo, eos: p?.eos,
});

const ProductPartAdd = ({ productpart, Update, Create, Delete, callback, clist }) => {
	const [errors, setErrors] = useState([]);
	const [isUp, setIsUp] = useState(false);
	const [isDel, setIsDel] = useState(false);
	const [options, setOptions] = useState([]);
	const [attachments, setAttachments] = useState([]);
	const { draft: item, editing, saving, errors: editErrors, formKey, onChange, setField, onEdit, onSave, onCancel } = useBatchEdit({
		source: productpart,
		toDraft,
		save: (changed) => Update(productpart._id, changed),
	});

	useEffect(() => {
		setCodes();
	}, [clist])

	const setCodes = async () => {
		const codes = Array.isArray(clist) ? clist : []; // BUG-157: 비배열 가드
		const filterList = [];
		console.log('PRODUCTEXTRAKEY', codes.filter(x => x.type === 'PRODUCTEXTRAKEY'));
		//var extradataList = await RayCodeAction.GetAllByFilter({ type: "PRODUCTEXTRAKEY" });
		const extradataList = codes.filter(x => x.type === 'PRODUCTEXTRAKEY');
		extradataList.filter(x => filterList.push({ code: "extradata." + x.code, title: x.name }));
		setOptions(filterList);
	}

	useEffect(() => {
		if (isDel && !productpart._id) {
			setIsDel(false);
			callback();
		} else {
			productpart?.guides && setAttachments(productpart.guides);
		}
	}, [productpart])

	// 신규 등록(isForm)은 전 칸이 열려 있고, 기존 항목은 [수정] 누른 뒤에만 연다.
	const fieldEditable = !productpart._id || editing;

	const form_controls = [
		{
			title: '',
			items: [
				{ type: 'input', name: 'type', label: t('common.field.type'), val: item.type, required: true, isEditable: fieldEditable },
				{
					type: "select2", name: "models", label: t('product.field.model'), size: 6, isMulti: "Y",
					val: item.models,
					list: DeviceModels.map(x => { return { code: x.code, title: x.title } }),
					isMulti: true,
					required: true,
					isEditable: fieldEditable
				},
				{ type: 'input', name: 'code', label: t('common.field.code'), val: item.code, required: true, isEditable: fieldEditable },
				{ type: 'input', name: 'name', label: t('common.field.name'), val: item.name, required: true, isEditable: fieldEditable },
				{
					type: "select2", name: "productextrakey", label: 'Related product key', size: 6,
					val: item.productextrakey,
					list: options,
					isEditable: fieldEditable
				},
				{ type: 'input', name: 'platformInfo', label: t('product.field.platform'), val: item.platformInfo, isEditable: fieldEditable },
				{ type: "checkbox", name: "eos", label: "EOS", val: item.eos || false, isEditable: fieldEditable },
			],
		},
	];

	const validAdd = () => {
		console.log("validAdd : ===", item);
		const errValidate = RayFormValidation(form_controls, item);
		if (errValidate.length > 0) {
			setErrors(errValidate);
		} else {
			setIsUp(true);
			//Add({ ...newErrorCode, attachments: attachments });
			Create({ ...productpart, ...item, guides: attachments });
		}
	};

	const del = () => {
		setIsDel(true);
		Delete(productpart._id);
	}

	const filelist = (list) => {
		if (productpart._id) {
			Update(productpart._id, { guides: list });
		} else {
			setField("guides", list);
		}
	};

	const setNewFile = (files) => {
		console.log("setNewFile", files);
		const addNewFile = files.find(f => !f._id) || false;
		if (productpart?._id) {
			if (addNewFile) {
				Update(productpart._id, {name: addNewFile?.name, path: addNewFile?.path}, "attachment");
			}
			Update(productpart._id, { guides: files });
		} else {
			setAttachments([...files]);
		}
    };

	return (
		<>
			{productpart._id && <RayForm key={formKey} controls={form_controls} handleChangeData={onChange} errors={editErrors} />}
			{productpart._id && <div className="section"><EditSaveCancelBar canEdit={true} editing={editing} onEdit={onEdit} onSave={() => onSave(form_controls)} onCancel={onCancel} saving={saving} /></div>}
			{!productpart._id && <RayForm controls={form_controls} isForm={true} handleChangeData={onChange} errors={errors} />}
			<div className="section">
				<div className="section-title">
					{t('common.label.attachments')}
				</div>
				<FileAddList callback={setNewFile} isForm={true} basepath="docs/productpart/" itemlist={attachments} />
				{!productpart._id && <button className="btn btn-primary" onClick={() => validAdd()}>{t('common.button.add')}</button>}
				{productpart._id && <RayDelButton callback={() => del()} />}
				<button className="btn btn-default" onClick={() => callback()}>{t('common.button.cancel')}</button>
			</div>
		</>
	)
};

const mapState = (state) => {
	const productpart = state.ProductPartReducer.item;
	const clist = state.RayCodeReducer.items;
	return { productpart, clist };
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data, type) => dispatch(ProductPartAction.Update(_id, data, type)),
	Delete: (_id) => dispatch(ProductPartAction.Delete(_id)),
	Create: (data) => dispatch(ProductPartAction.Create(data)),
});

export default connect(mapState, mapDispatch)(ProductPartAdd);
